import LandingPageCTA from './index';

const LandingPageCTABlock = {
  Component: LandingPageCTA,
  BlockRenderer: () => <LandingPageCTA />,
  metadata: {
    name: 'rentals/landing-page-cta',
    title: 'Rentals Landing Page CTA',
    description: '',
    icon: 'businessperson',
    keywords: ['cta', 'rentals'],
    supports: {
      customClassName: false,
      html: false,
    },
    category: 'more',
    attributes: {},
  },
};

export default LandingPageCTABlock;
